/**
 * EliseWidget
 *
 * Routes "Schedule a Tour" links into the EliseAI website widget's self-scheduling
 * tab instead of the site's own modal, so tours booked on the site land in the same
 * calendar the AI assistant reads from.
 *
 * The widget is loaded in _layout.twig via `MEChat.start()`.
 */
var EliseWidget = function (options) {

	this.options = {
		selector: 'a[href="#schedule-tour"]',
		readyTimeout: 5000,
		pollInterval: 100
	};

	$.extend(true, this.options, options);

};

EliseWidget.prototype.init = function () {

	this.interceptTriggers();

};

/**
 * MEChat.start() creates an empty window.eliseAi immediately, but only attaches
 * onOpenSST once the widget component renders after fetching its settings, and it
 * fires no ready event. Polling for the method itself is the only reliable signal.
 */
EliseWidget.prototype.getScheduler = function () {

	if (window.eliseAi && typeof window.eliseAi.onOpenSST === 'function')
		return window.eliseAi.onOpenSST;

	return null;

};

/**
 * Bound on the capture phase so it runs ahead of Sitewide's per-anchor smooth
 * scroll handler and Modal's delegated trigger handler, both of which also claim
 * `a[href^="#"]` clicks. stopImmediatePropagation keeps the event from ever
 * reaching them. Capture on document also covers anchors added after page load,
 * which Sitewide's direct binding misses.
 */
EliseWidget.prototype.interceptTriggers = function () {

	var self = this;

	document.addEventListener('click', function (e) {

		var $link = $(e.target).closest(self.options.selector);

		if (!$link.length)
			return;

		e.preventDefault();
		e.stopImmediatePropagation();

		self.openTourScheduler($link);

	}, true);

};

/**
 * Availability is polled from the click rather than from page load, because the
 * widget can take upwards of ten seconds to render and any deadline measured from
 * load would strand clicks made while it was still on its way.
 */
EliseWidget.prototype.openTourScheduler = function ($link) {

	var self = this;
	var deadline = Date.now() + self.options.readyTimeout;

	var attempt = function () {

		var scheduler = self.getScheduler();

		if (scheduler) {
			scheduler();
		} else if (Date.now() >= deadline) {
			self.openFallbackModal($link);
		} else {
			setTimeout(attempt, self.options.pollInterval);
		}

	};

	attempt();

};

/**
 * The widget is absent whenever its CDN is blocked or slow, so clicks fall back to
 * whichever modal the CMS registered against the trigger.
 */
EliseWidget.prototype.openFallbackModal = function ($link) {

	var href = $link.attr('href');
	var triggerKey = href.replace(/^#/, '');

	var modal = window.ModalTriggers && (window.ModalTriggers[href] || window.ModalTriggers[triggerKey]);

	if (modal) {
		modal.open();
		return;
	}

	console.warn('EliseWidget: tour scheduler unavailable and no fallback modal registered for', href);

};

export default EliseWidget;
